import { Swiper, Navigation, Autoplay } from "swiper/bundle";
import Plyr from "plyr";
export default class SwiperSingle {
    constructor() {
        console.log('%c👍🏼 Swiper Single', 'color: yellow');
        
        this.swiperSingle = document.querySelectorAll('.swiper-single')
    }
    init() {
        this.swiperSingle.forEach((module, i) => {

            const elem = module.querySelector('.swiper--single');

            const nextButton = module.querySelector('.swiper-button-next')
            const prevButton = module.querySelector('.swiper-button-prev')
            const pagination = module.querySelector('.swiper-pagination')
            let swip = new Swiper(elem, {
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: false,
                spaceBetween: 0,
                freeMode: false,
                shortSwipes: false,
                longSwipes: false,
                speed: 1001,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                pagination: {
                    el: pagination,
                    type: 'bullets',
                    clickable: true
                  },
            });   


            const pageVideos = module.querySelectorAll('.plyr__video__wrapper--muted');
                pageVideos.forEach((pageVideo, i) => {
                const videoPlayer = new Plyr(pageVideo, {
                    loop: { active: true },
                    autoplay:  true,
                    youtube: { 
                        autoplay: true,
                        noCookie: true,
                        rel: 0, 
                        showinfo: 0, 
                        iv_load_policy: 3, 
                        modestbranding: 1,
                        muted: true
                    },
                    vimeo: {
                        muted: true
                    },
                    muted: true
                });
            });

            const pageVideosControls = module.querySelectorAll('.plyr__video__wrapper--controls');
                pageVideosControls.forEach((pageVideo, i) => {
                const videoPlayer = new Plyr(pageVideo, {
                    loop: { active: true },
                    autoplay: false,
                    youtube: { 
                        autoplay: false,
                        noCookie: true,
                        rel: 0, 
                        showinfo: 0, 
                        iv_load_policy: 3, 
                        modestbranding: 1,
                        muted: false
                    },
                    vimeo: {
                        muted: false
                    },
                    muted: false
                });

                videoPlayer.volume = 0.5;
            });

        
        });
    }

}